import { EpimsBaseEntityDto } from './epim-base.dto';

import { IsNotEmpty } from 'class-validator';
import { ScholarshipTypeDto } from './scholarship-type.dto';

export class ScholarshipCategoryDto extends EpimsBaseEntityDto {
	@IsNotEmpty() ScholarshipCategoryId: string;
	@IsNotEmpty() ScholarshipCategoryName: string;
	@IsNotEmpty() SubscriberId: string;
	scholarshipTypes?: ScholarshipTypeDto[];
}
